import { render, staticRenderFns } from "./checkpoint.vue?vue&type=template&id=164456f2&scoped=true&"
import script from "./checkpoint.vue?vue&type=script&lang=js&"
export * from "./checkpoint.vue?vue&type=script&lang=js&"
import style0 from "./checkpoint.vue?vue&type=style&index=0&id=164456f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164456f2",
  null
  
)

export default component.exports